import React from 'react';
import './ToggleSwitch.css';

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: React.ReactNode;
  /** Accessible name when there is no visible label. */
  ariaLabel?: string;
  disabled?: boolean;
  id?: string;
  name?: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  label,
  ariaLabel,
  disabled = false,
  id,
  name,
}) => {
  const switchEl = (
    // NOTE: deliberately NOT `.toggle-switch` — App.css has a legacy global
    // .toggle-switch (track + ::after knob) that would collide.
    <span className="toggle-switch-control">
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        aria-label={ariaLabel}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="toggle-switch__slider" aria-hidden="true" />
    </span>
  );

  // Always wrap in a <label> so the visually-hidden input toggles when the
  // slider is clicked. Without this, a label-less toggle renders a 0×0 input
  // and an unwired slider span — i.e. nothing clickable. Omit the text span
  // when no label is provided.
  return (
    <label className={`toggle-switch__label${disabled ? ' toggle-switch__label--disabled' : ''}`}>
      {switchEl}
      {label !== undefined && <span className="toggle-switch__text">{label}</span>}
    </label>
  );
};

export default ToggleSwitch;
